<template>
  <div>
    <ctlHomeNav />
    <v-container fluid>
      <ctlItemProductNav />
      <ctlHmRagChat />
    </v-container>
  </div>
</template>

<script>
import ctlHomeNav from '@/components/ctlHomeNav'
import ctlHmRagChat from '@/components/ctlHmRagChat'
import ctlItemProductNav from '@/components/ctlItemProductNav'

export default {
  components: {
    ctlHomeNav,
    ctlHmRagChat,
    ctlItemProductNav
  }
}
</script>
